var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKakaoTalk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 176 176",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_56.kakao-talk",
    "data-name": "56.kakao-talk"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m60.76 74c-.92 14.09 2.31 21.73-3.17 21.73s-2.25-7.62-3.17-21.73c-2-.34-8.07 1.36-8.07-3.09a3.1 3.1 0 0 1 3.11-3.08c11.54.82 19.36-2.15 19.36 3.08 0 4.5-5.82 2.68-8.06 3.09z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m80.59 70.91a4.44 4.44 0 0 0 -8.45 0c-4.51 14-10.55 22.62-6.84 24.32 4.94 2.24 5-2.8 6.23-5h9.67c1.18 2.23 1.3 7.28 6.23 5 3.73-1.71-2.24-10.07-6.84-24.32zm-7.39 13.69 3.17-8.94 3.16 8.94z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m106.51 92.35c0 4.61-7.22 2.3-13.22 2.89-5.31 0-2.08-7.17-3-24.3 0-4.17 6.48-4.16 6.48 0v18.52c3.02.41 9.74-1.46 9.74 2.89z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m127.69 90.53c2.55 3.33-2.54 7.13-5.06 3.8l-7.44-9.8-1.1 1.1v6.87a3.16 3.16 0 0 1 -3.18 3.16c-5.51 0-2.21-7.94-3.17-24.72a3.17 3.17 0 0 1 3.17-3.15c4.79 0 2.72 6.77 3.17 9.93 9-8.59 8.77-9.5 10.62-9.5 2.55 0 4.11 3.17 2.41 4.85l-7.23 7.18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m159.67 0h-143.34a16.33 16.33 0 0 0 -16.33 16.33v143.34a16.33 16.33 0 0 0 16.33 16.33h143.34a16.33 16.33 0 0 0 16.33-16.33v-143.34a16.33 16.33 0 0 0 -16.33-16.33zm-71.67 123.74a69.58 69.58 0 0 1 -9.77-.68c-31.66 22.17-27.14 20.45-19.45-5.9-15.49-7.62-25.78-21.11-25.78-36.5 0-23.79 24.63-43.07 55-43.07s55 19.28 55 43.07-24.63 43.08-55 43.08z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKakaoTalk);
export default __webpack_public_path__ + "static/media/kakao-talk.e119bedd537d359fdce7cfcfb4c3ad93.svg";
export { ForwardRef as ReactComponent };